
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import axios from '../../API/axios';
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ModalForGuest from '../ModalForGuest';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import WorkOffSharpIcon from '@mui/icons-material/WorkOffSharp';
import { useTranslation } from 'react-i18next';
import { Portal } from "../../components/Portal";


const JobApplyModals = ({ action, showApplyModal, isAppliedByYou, jobId, getAllJobList, item, profileConfig, userPer, AddUserCcv, userCcv, onActionClose }) => {

    console.log('isAppliedByYou', isAppliedByYou);

    const [checkApplied, setCheckApplied] = useState(isAppliedByYou);

    const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");
    const ProfilePercent = localStorage.getItem("ProfilePercentage");
     // console.log('ProfilePercent', ProfilePercent < 60);
    const { t } = useTranslation();
    const userUid = localStorage.getItem("userUid");
    const [showResumeModal, setShowResumeModal] = useState(false);
    const language = localStorage.getItem("Lang");

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const [bookmarkModal, setBookmarkModal] = useState(false);
    const [showAppliedModal, setShowAppliedModal] = useState(false);
    const handleShow = () => setShowAppliedModal(true);
    const handleCloseModal = () => setShowAppliedModal(false);
    const closeModalData = () => {
        setBookmarkModal(false);
    };
    const applyNew = async () => {
        try {
            const body = {
                deviceType: "Web",
                sessionId: sessionId,
                jobId: jobId,
                type: 1,
                userUid: userUid,
                langKey: language === "en" ? "" : language,
            };
            const res = await axios.post("/JobAction/ApplyJob", body);
            setToastMessage(res.data.message);
            setShowToast(true);
            getAllJobList();
            setCheckApplied(true)
            // setAppliedId(jobId);
            onActionClose()
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
                onActionClose();
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
                onActionClose()
            }
        }
    };

    const unapplyNew = async () => {
        try {
            const body = {
                deviceType: "Web",
                sessionId: sessionId,
                jobId: jobId,
                type: 1,
                userUid: userUid,
                langKey: language === "en" ? "" : language,
            };
            const res = await axios.post("/JobAction/UnApplyJob", body);
            setToastMessage(res.data.message);
            setShowToast(true);
            handleCloseModal();
            getAllJobList();
            setCheckApplied(false)
            onActionClose()
            // setAppliedId(appliedJobId);
        } catch (e) {
            console.log(e.response.data.message);
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
                onActionClose()
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
                onActionClose()
            }
        }
    };
    console.log('isAppliedByYou', checkApplied);

    useEffect(() => {
        if(action === 'apply' && showApplyModal) {
            if(guestModeData === "true") {
                setBookmarkModal(true)
            }
            if(guestModeData !== "true") {
                if((profileConfig.hasCcv === null || profileConfig.hasCcv === false) && 
                ProfilePercent < 60) {
                    setShowResumeModal(!showResumeModal)
                } else {
                    applyNew()
                }
            }
        }

        if(action === 'unapply' && showApplyModal) {
            handleShow();
        }
        

    }, [action])

    return (
        <>
            {/* <div className="mt-auto jobAction d-flex justify-content-between">
                {item?.isOwned !== true ? (
                    checkApplied === true ? (
                        <button
                            className="mainBtn  appliedBtn"
                            style={{ width: '100px' }}
                            onClick={() => {
                                guestModeData === "true"
                                    ? setBookmarkModal(true)
                                    : handleShow();
                                // setIsappliedF(false);
                            }}
                        >
                            <span className="default-text">Applied</span>
                            <span className="hover-text">Unapply</span>
                        </button>
                    ) : (
                        <button
                            className="mainBtn"
                            onClick={() =>
                                guestModeData === "true"
                                    ? setBookmarkModal(true)
                                    : (profileConfig.hasCcv === null || profileConfig.hasCcv === false) &&
                                        userPer?.percentage < 60
                                        ? setShowResumeModal(!showResumeModal)
                                        : (applyNew())
                            }
                        >
                            Apply Now
                        </button>
                    )
                ) : (
                    ""
                )}
            </div > */}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />


            {
                showResumeModal && (
                    <Portal layer="modal">
                    <div
                        className="modal fade show postAdd wlj-overlay-modal"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "flex" }}
                    >
                        <div className="modal-dialog  modal-dialog-centered " role="document">
                            <div className="modal-content d-flex justify-content-around p-2">
                                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                    <h6>{t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}</h6>

                                    {/* <span
                                        className="material-symbols-sharp me-2 pointer"
                                        onClick={() => {
                                            setShowResumeModal(false);
                                        }}
                                    >
                                        close
                                    </span> */}
                                    <CloseSharpIcon
                                        className="material-symbols-sharp me-2 pointer"
                                        onClick={() => {
                                            setShowResumeModal(!showResumeModal);
                                            onActionClose()
                                        }}
                                    />
                                </div>
                                <div className="text-center mt-2">
                                    <Link to={`/User/${userUid}`}>
                                        <button
                                            color=""
                                            className="closebtn"
                                            style={{ width: "150px" }}
                                            // onClick={() => {
                                            //     userCcv !== "True" && AddUserCcv();
                                            // }}
                                        >
                                            Manage Profile
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    </Portal>
                )
            }


            {
                showAppliedModal && (
                    <Portal layer="modal">
                    <div
                        className="modal fade show postAdd wlj-overlay-modal"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "flex" }}
                    >
                        <div className="modal-dialog  modal-dialog-centered " role="document">
                            <div className="modal-content d-flex justify-content-around p-2">
                                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                    <h6 className="wlj-modal-title--danger">
                                        <WorkOffSharpIcon className="material-symbols-sharp" />
                                        {t("modals.Are you sure you want to unapply this job?")}
                                    </h6>

                                    {/* <span
                                        className="material-symbols-sharp me-2 pointer"
                                        onClick={() => {
                                            handleCloseModal();
                                        }}
                                    >
                                        close
                                    </span> */}
                                    <CloseSharpIcon
                                        className="material-symbols-sharp me-2 pointer"
                                        onClick={() => {
                                            handleCloseModal();
                                            onActionClose()
                                        }}
                                    />
                                </div>


                            {/* <p className='text-center mt-4'>{t("modals.Are you sure you want to unapply this job?")}</p> */}
                                <div className="col-md-12 text-end mt-4 d-flex justify-content-end wlj-modal-footer">
                                    <button
                                        type="button"
                                        className="wljDangerBtn"
                                        onClick={() => unapplyNew()}
                                    >
                                        <WorkOffSharpIcon />
                                        {t("Manage Job.Unapply")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </Portal>
                )
            }
            {bookmarkModal && <ModalForGuest closeModalData={closeModalData} />}
        </>
    )
}

export default JobApplyModals